import { AxiosPost } from "utilities/Axios";

export const GetDataAll = (fnSuccess) => {
    AxiosPost("AdminUser/onGetDataAll", {}, fnSuccess, null, null, null, () => {});
};

//#region Table 
export const LoadDataToTable = (ObjData, fnSuccess, BlockUI, UnBlockUI) => {
    BlockUI();
    AxiosPost("AdminUser/onLoadDataToTable", ObjData, fnSuccess, null, null, null, () => {
        UnBlockUI();
    })
};

export const DeleteUser = (ObjData, fnSuccess, BlockUI, UnBlockUI) => {
    BlockUI();
    AxiosPost("AdminUser/onDelete", ObjData, fnSuccess, null, null, null, () => {
        UnBlockUI();
    })
};
//#endregion Table

//#region Form
export const GetDataFormID = (ObjData, fnSuccess, BlockUI, UnBlockUI) => {
    BlockUI();
    AxiosPost("AdminUser/onGetDataFormID", ObjData, fnSuccess, null, null, null, () => {
        UnBlockUI();
    })
};

export const SaveData = (ObjData, fnSuccess, BlockUI, UnBlockUI) => {
    BlockUI();
    AxiosPost("AdminUser/onSaveData", ObjData, fnSuccess, null, null, null, () => {
        UnBlockUI();
    })
};
//#endregion Form

